import { FEATURE_TYPE, MapDrawType, MapSelectAssetType } from "./map-library";

export class AddressDetails {
    type;
    properties = {};
    geometry = {};

    constructor() {
        this.type = FEATURE_TYPE.FEATURE;
        this.properties = {
            type: MapSelectAssetType.STREET,
            unitNo: '',
            streetNo: '',
            street: '',
            suburb: '',
            postcode: '',
            locationDescription: '',
            country: '',
            iconImage: '',
            iconSize: '',
            state: ''
        };
        this.geometry = {
            type: MapDrawType.POINT,
            coordinates:[]
        }
    }
}